import moment from 'moment';
// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';
import { SgDateUtil } from 'saga-modules';

const VERSIONS = {
    MP1: 'PROMISE_MP1', // P1 for motor
    MP2: 'PROMISE_MP2', // P2 for motor
    HP1: 'PROMISE_HP1', // P1 for home
    HP1A: 'PROMISE_HP1A' // P1A for home

};
const DRAFT_FIELD_NAMES = {
    PROMISE_MP1: 'isPromiseMP1Active',
    PROMISE_MP2: 'isPromiseMP2Active',
    PROMISE_HP1: 'isPromiseHP1Active',
    PROMISE_HP2: 'isPromiseHP2Active'
};

// uncomment when needed
/* const CONTEXT_NAMES = {
    PromiseHP1Active: 'PROMISE_HP1',
    PromiseMP1Active: 'PROMISE_MP1'
}; */
const propositionData = {};
const seenPropositionsOnQuotePage = {};
const currentVersion = {};

function getEffectiveDate(model) {
    return model && model.baseData.value.periodStartDate;
}

function checkIfPropositionIsActive(version, model) {
    let result = false;
    const effectiveDate = getEffectiveDate(model);
    if (SgDateUtil.dateIsValid(effectiveDate) && propositionData[version] && propositionData[version].startDate) {
        const effDate = SgDateUtil.toDateString(effectiveDate);
        const isAfterStartDate = !moment(effDate).isBefore(moment(propositionData[version].startDate));
        const isBeforeEndDate = !moment(effDate).isAfter(moment(propositionData[version].endDate));
        result = isAfterStartDate && isBeforeEndDate;
    }
    return result;
}

function setModel(modelVM) {
    if (!modelVM) {
        return;
    }
    const model = modelVM.value;
    if (!model.baseData.propositions_Ext) {
        model.baseData.propositions_Ext = {};
    }
    Object.keys(propositionData).forEach((version) => {
        const isActive = checkIfPropositionIsActive(version, modelVM);
        model.baseData.propositions_Ext[DRAFT_FIELD_NAMES[version]] = isActive;
        if (isActive !== currentVersion[version]) {
            // $rootScope.$emit(`propositionChanged:${version}`, isActive);
        }
        currentVersion[version] = isActive;
    });
}

function getActiveVersion() {
    let activeVersion = '';
    Object.keys(propositionData).forEach((key) => {
        if (checkIfPropositionIsActive(key)) {
            activeVersion = key;
        }
    });
    return activeVersion;
}

function updateSeenQuotePage() {
    const activeVersion = getActiveVersion();
    if (activeVersion) {
        seenPropositionsOnQuotePage[activeVersion] = true;
    }
}

function fillPropositions(propositions) {
    propositions.forEach((proposition) => {
        propositionData[proposition.name] = {
            startDate: proposition.startDate,
            endDate: proposition.endDate
        };
        currentVersion[proposition.name] = false;
    });
}

function init() {
    if (appConfig.propositionOfferings) {
        fillPropositions(appConfig.propositionOfferings);
    }
}

function isPropositionActive(versions) {
    let result;
    if (Array.isArray(versions)) {
        result = versions.some((version) => checkIfPropositionIsActive(version));
    } else {
        result = checkIfPropositionIsActive(versions);
    }
    return result;
}

// uncomment when needed
/* function isPropositionActiveForContext(contextName) {
    return isPropositionActive(CONTEXT_NAMES[contextName]);
} */

function updatePropositions(modelVM) {
    setModel(modelVM);
}

init();

export default {
    VERSIONS,

    /*
        For manual update after entering quote page
     */
    updateSeenQuotePage,

    /*
        Overriding context validation for proposition on portal - on specified items we do not have context before saving item.
        That is preventing P1 validation rules from being checked
     */
    // isPropositionActiveForContext,

    /*
        If proposition has been active on quote page and then removed due to effective date change
    */
    propositionHasBeenRemoved: (version) => seenPropositionsOnQuotePage[version] && !isPropositionActive(version),

    /* update when date changed */
    updatePropositions,

    /* get propositions values */
    getPropositions: () => {
        return {
            propositions: currentVersion
        };
    },
};
